import { makeStyles } from '@material-ui/core'

export const useDealInformationFormStyles = makeStyles(theme => ({
  paper: {
    flex: 1,
    padding: '3rem',
    marginBottom: '2rem',
    '&:first-child': {
      marginRight: '1rem',
    },
    '&:nth-child(2)': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    '&:nth-child(3)': {
      flexBasis: '100%',
      marginBottom: 0,
    },
  },
  tableContainer: {
    marginY: theme.spacing(3),
    maxHeight: 500,
  },
  formContainer: {
    marginTop: '1.625rem',
  },
  heading: {
    fontSize: '2.25rem',
    color: theme.palette.text.secondary,
    marginBottom: '1rem',
  },
  notificationPreferencesLabel: {
    fontSize: '1.0625rem',
    color: theme.palette.text.secondary,
  },
  switch: {
    marginBottom: '2.75rem',
  },
  selectLabel: {
    color: theme.palette.secondary.dark,
  },
  selectWithAdornment: {
    '& .MuiSelect-iconOutlined': {
      right: '3rem',
    },
  },
  paymentDayAdornment: {
    marginRight: '-0.5rem',
  },
  paymentDayButton: {
    padding: '0.375rem',
    minWidth: '2.25rem',
    fontSize: '1rem',
    color: theme.palette.secondary.dark,
  },
  paymentDayPopover: {
    width: 320,
    padding: 20,
  },
  button: {
    marginRight: '1.25rem',
    background: theme.palette.info.light,
  },
  icon: {
    '& path': {
      fill: theme.palette.info.contrastText,
    },
  },
  checkboxLabel: {
    color: theme.palette.secondary.dark,
    fontSize: '1.0625rem',
    marginBottom: -3,
  },
  checkboxGrid: { paddingTop: '0 !important', paddingBottom: '0 !important', display: 'flex' },
  comission: {
    color: theme.palette.text.secondary,
    fontWeight: 600,
    fontSize: '1.0625rem',
    marginRight: '2rem',
  },
  root: {
    width: 300,
    padding: 20,
  },
  popoverFlex: {
    width: 550,
    padding: 20,
  },
  popoverPositions: {
    width: 500,
    minWidth: 300,
    padding: 20,
  },
  popoverTextField: {
    marginTop: 20,
    marginBottom: 20,
  },
  popoverContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
}))

export const useCustomizedScheduleModalStyles = makeStyles(theme => ({
  dialogTitle: {
    backgroundColor: 'white',
    padding: '16px 24px',
  },
  dialogTitleContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  dialogTitleText: {
    fontSize: '1.5rem',
  },
  closeButton: {
    color: theme.palette.text.secondary,
  },
  tabsContainer: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tab: {
    backgroundColor: 'transparent',
    color: '#249AF3',
    border: `1px solid #249AF3`,
    borderRadius: '20px',
    marginRight: '8px',
    minHeight: '32px',
    padding: '4px 16px',
    textTransform: 'none',
    fontWeight: 'normal',
    '&.Mui-selected': {
      backgroundColor: '#249AF3',
      color: 'white',
    },
  },
  paybackAmountContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  paybackAmountFields: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  paybackAmountField: {
    backgroundColor: theme.palette.grey[100],
  },
  percentageField: {
    backgroundColor: theme.palette.grey[100],
    width: 100,
  },
  distributeButton: {
    background: theme.palette.primary.main,
    color: 'white',
    marginLeft: 'auto',
  },
  sumToPayContainer: {
    marginTop: theme.spacing(6),
  },
  sumToPayLabel: {
    marginBottom: theme.spacing(1),
  },
  requiredAsterisk: {
    color: theme.palette.error.main,
  },
  paymentRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '8px 0',
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  paymentLabel: {
    minWidth: 80,
    fontWeight: 500,
  },
  paymentAmountField: {
    flex: 1,
  },
  paymentPercentageField: {
    backgroundColor: theme.palette.grey[100],
    width: 120,
  },
  deleteButton: {
    padding: '4px',
    '&.disabled': {
      color: theme.palette.grey[400],
    },
    '&:not(.disabled)': {
      color: theme.palette.error.main,
    },
  },
  addPaymentButton: {
    marginTop: '0.5rem',
  },
  dialogActions: {
    padding: '16px 24px',
    backgroundColor: 'white',
    gap: '12px',
  },
  cancelButton: {
    textTransform: 'none',
    padding: '8px 24px',
    flex: 1,
  },
  saveButton: {
    background: theme.palette.primary.main,
    color: 'white',
    padding: '8px 24px',
    flex: 1,
  },
}))
